module.exports = __webpack_public_path__ + "img/ic_facebook_default.441c9630.svg";